import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/staff-report/staff-profiles.css";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import StaffProfilesListings from "../../components/staff-report/staff-profiles/StaffProfilesListings";
import { fetchStaffProfilesData } from "../../redux/prospect-reducers/prospectSlice";
import { NoPic } from "../../exports/Images";
import DetailModHeader from "../../components/common-components/DetailModHeader";
import StaffProfileApprovalForm from "../../components/staff-report/staff-profiles/StaffProfileApprovalForm";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const StaffProfiles = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { staffProfilesLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedStaff: "",
    selectedStaffType: "",
    selectedStakeholderApprovalStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    user_id: allFilters.selectedStaff?.value || "",
    account_type: allFilters.selectedStaffType?.value || "",
    status: allFilters.selectedStakeholderApprovalStatus?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getStaffProfiles(filters) {
    dispatch(
      fetchStaffProfilesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getStaffProfiles(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      user_id: allFilters.selectedStaff?.value || "",
      account_type: allFilters.selectedStaffType?.value || "",
      status: allFilters.selectedStakeholderApprovalStatus?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedStaff,
    allFilters.selectedStaffType,
    allFilters.selectedStakeholderApprovalStatus,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  return (
    <HelmetWrapper title="WTF: Staff Profiles">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer mod-width-50p ${
              modValues.modName === "view_details" ? "" : ""
            }`}
          >
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />

            {modValues.modName === "image_view" ? (
              <div className="discussionModalMessage mt30">
                <img
                  src={modValues.image || NoPic}
                  alt="profile"
                  style={{
                    width: "400px",
                    height: "400px",
                  }}
                />
              </div>
            ) : modValues.modName === "view_details" ? (
              <StaffProfileApprovalForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                callFunction={() => getStaffProfiles(filters)}
                onCloseModal={onCloseModal}
              />
            ) :
            
            null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Staff Profiles"}
              isReload={() => getStaffProfiles(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"staff-profiles"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              isLoading={staffProfilesLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <StaffProfilesListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default StaffProfiles;
